<div *ngIf="view == 1" class="row p-3">
  <div class="col-lg-5 col-md-5 col-sm-6">
    <div class="row">
      <div
        class="col-xl-5 col-lg-6 col-md-6 col-sm-12 justify-content-md-end justify-content-lg-end justify-content-xl-end align-items-center d-flex">
        Vendor name :</div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <input autocomplete="nope" type="text" placeholder="" maxlength="100" class="k-textbox form-control w-100"
          [(ngModel)]="search_company_name" [ngModelOptions]="{standalone: true}" />
      </div>
    </div>
  </div>

  <div class="col-lg-5 col-md-5 col-sm-6">
    <div class="row">
      <div
        class="col-xl-5 col-lg-6  col-md-6 col-sm-12 justify-content-md-end justify-content-lg-end justify-content-xl-end  align-items-center d-flex">
        Hashtag :</div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <input autocomplete="nope" type="text" placeholder="" maxlength="50" class="k-textbox form-control w-100"
          [(ngModel)]="search_hashtag" [ngModelOptions]="{standalone: true}" />
      </div>
    </div>
  </div>

  <div class="col-lg-2 col-md-2 d-flex align-items-end justify-content-end">
    <div class="mt-1">
      <button type="button" (click)="search()" class="btn btn-primary pull-right text-white"> <i
          class="fa fa-search"></i>
        ค้นหา </button>
    </div>
  </div>
  <div class="col-12 mt-3 table-header pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between">
    <div class="font-2">
      <i class="fa fa-bars mr-2"></i> Vendor
    </div>
    <button *ngIf="isAdd" (click)="openAddModel()" type="button" class="btn btn-primary text-white"> <i class="fa fa-plus"></i>
      เพิ่ม Vendor</button>
  </div>
  <div class="col-12 mt-3">
    <table class="table table-outline mb-0">
      <thead class="thead-dark" style="background-color: black;">
        <tr>
          <th class="text-center text-light table-header"><i class="fa fa-hashtag"></i></th>
          <th class="text-center text-light table-header">สถานะ</th>
          <th class="text-center text-light table-header">Vendor name</th>
          <th class="text-center text-light table-header">Hashtag</th>
          <th class="text-center text-light table-header">Create date</th>
          <th *ngIf="isEdit" class="text-center text-light table-header">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!this.is_loading && data_list?.length == 0">
          <td colspan="10" style="height: 50px;">
            ไม่พบข้อมูล
          </td>
        </tr>
        <tr *ngIf="this.is_loading">
          <td colspan="10" style="height: 50px;">
            กำลังโหลด ..
          </td>
        </tr>
        <tr *ngFor="let item of data_list;index as i;">
          <td class="text-center">
            <div>
              {{(i+1)+((this.currentPage - 1)*itemsPerPage)}}
            </div>
          </td>
          <td class="text-center">
            <!-- <span *ngIf="item?.status == 0" class="badge badge-danger">{{item?.status_str}}</span>
                  <span *ngIf="item?.status == 1" class="badge badge-success">{{item?.status_str}}</span> -->
            <!-- <i [ngClass]="{ 'text-success': item?.status == 1,'text-danger': item?.status == 0 }"
                    class="fa fa-circle mr-1"></i> <span>{{item?.status_str}}</span> -->

            <i tooltip="Active" placement="top" *ngIf="item?.status == statusEnum.Active"
              class="fa fa-circle text-success"></i>
            <i tooltip="Inctive" placement="top" *ngIf="item?.status == statusEnum.Inactive"
              class="fa fa-circle text-danger"></i>
          </td>
          <td class="text-center">
            {{item?.company_name}}
          </td>
          <td class="text-center">
            {{item?.hashtag}}
          </td>
          <td class="text-center">
            <div style="font-size: 12px;">{{item?.create_date | date: 'dd/MM/yyyy'}}</div>
          </td>

          <td *ngIf="isEdit" class="text-center">
            <div class="d-flex align-items-center justify-content-center">
              <button (click)="changeView(2,item)" title="รายละเอียด" type="button"
                class="btn btn-sm btn-info mr-1 text-light">
                <i class="icon-info"></i>
              </button>
              <button (click)="openDeleteModel(item)" title="ลบ" type="button" class="btn btn-sm btn-danger ml-1">
                <i class="cui-trash icons"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="12" class="table-footer">
            <div class="table-footer-inside d-flex align-items-center justify-content-between">
              <div class="ml-3 pt-3">
                <pagination [totalItems]="totalItems" [maxSize]="5" [itemsPerPage]="itemsPerPage"
                  [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)" class="pagination"
                  previousText="&lsaquo;" nextText="&rsaquo;" [boundaryLinks]="true" firstText="&laquo;"
                  lastText="&raquo;"></pagination>
              </div>
              <div></div>
              <div class="mr-3 ml-2">total: {{totalItems}}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="view == 2" class="row pr-3 pl-3 pb-3">
  <div class="col-12 table-header pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between">
    <div class="font-2">
      <i class="fa fa-bars mr-2"></i> Vendor
    </div>
    <button title="ปิด" (click)="changeView(1)" type="button" class="btn btn-danger text-white"> <i
        class="fa fa-times"></i></button>
  </div>
  <div class="col-12">
    <div class="row mt-3">
      <div class="col-lg-5 col-md-5 col-sm-6">
        <div class="row">
          <div
            class="col-xl-5 col-lg-6 col-md-6 col-sm-12 justify-content-md-end justify-content-lg-end justify-content-xl-end align-items-center d-flex">
            Vendor name :</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            {{selectItem?.company_name}}
          </div>
        </div>
      </div>

      <div class="col-lg-5 col-md-5 col-sm-6">
        <div class="row">
          <div
            class="col-xl-5 col-lg-6  col-md-6 col-sm-12 justify-content-md-end justify-content-lg-end justify-content-xl-end  align-items-center d-flex">
            สถานะ :</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <span *ngIf="selectItem?.status == statusEnum.Active"><i tooltip="Active" placement="top"
                class="fa fa-circle text-success mr-2"></i> Active</span>
            <span *ngIf="selectItem?.status == statusEnum.Inactive"><i tooltip="Inctive" placement="top"
                class="fa fa-circle text-danger mr-2"></i>Inactive</span>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-2 d-flex align-items-end justify-content-end">
        <div class="mt-1">
          <button type="button" (click)="openEditModel(selectItem)" class="btn btn-primary pull-right text-white"> <i
              class="cui-note icons"></i>
            แก้ไข </button>
        </div>
      </div>
    </div>

  </div>

  <div class="col-12 mt-3 table-header pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between">
    <div class="font-2">
      <i class="fa fa-bars mr-2"></i> Vendor contact
    </div>
    <button *ngIf="isAddContact" (click)="openAddModelSub()" type="button" class="btn btn-primary text-white"> <i class="fa fa-plus"></i>
      Add Vendor contact</button>
  </div>
  <div class="col-12 mt-3">
    <table class="table table-outline mb-0">
      <thead class="thead-dark" style="background-color: black;">
        <tr>
          <th class="text-center text-light table-header"><i class="fa fa-hashtag"></i></th>
          <th class="text-center text-light table-header">สถานะ</th>
          <th class="text-center text-light table-header">Vendor contact</th>
          <th class="text-center text-light table-header">Vendor type</th>
          <th class="text-center text-light table-header">Create date</th>
          <th *ngIf="isEditContact" class="text-center text-light table-header">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!this.is_loading && data_sub_list?.length == 0">
          <td colspan="10" style="height: 50px;">
            ไม่พบข้อมูล
          </td>
        </tr>
        <tr *ngIf="this.is_loading">
          <td colspan="10" style="height: 50px;">
            กำลังโหลด ..
          </td>
        </tr>
        <tr *ngFor="let item of data_sub_list;index as i;">
          <td class="text-center">
            <div>
              {{(i+1)}}
            </div>
          </td>
          <td class="text-center">
            <i tooltip="Active" placement="top" *ngIf="item?.status == statusEnum.Active"
              class="fa fa-circle text-success"></i>
            <i tooltip="Inctive" placement="top" *ngIf="item?.status == statusEnum.Inactive"
              class="fa fa-circle text-danger"></i>
          </td>
          <td class="text-center">
            {{item?.contact_name}}
          </td>
          <td class="text-center">
            <span *ngIf="item?.contact_type == vendorContactTypeEnum.Install">ผู้ติดตั้ง</span>
            <span *ngIf="item?.contact_type == vendorContactTypeEnum.Ma">ผู้ซ่อมบำรุง</span>
            <span *ngIf="item?.contact_type == vendorContactTypeEnum.InstallMa">ผู้ติดตั้ง/ผู้ซ่อมบำรุง</span>
          </td>
          <td class="text-center">
            <div style="font-size: 12px;">{{item?.create_date | date: 'dd/MM/yyyy'}}</div>
          </td>

          <td *ngIf="isEditContact" class="text-center">
            <div class="d-flex align-items-center justify-content-center">
              <button (click)="openEditModelSub(item)" title="แก้ไข" type="button"
                class="btn btn-sm btn-warning mr-1 text-light">
                <i class="cui-note icons"></i>
              </button>
              <button (click)="openDeleteModelSub(item)" title="ลบ" type="button" class="btn btn-sm btn-danger ml-1">
                <i class="cui-trash icons"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="12" class="table-footer">
            <div class="table-footer-inside d-flex align-items-center justify-content-between">
              <div class="ml-3 pt-3">

              </div>
              <div></div>
              <div class="mr-3 ml-2">total: {{totalSubItems}}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<div bsModal #addModal="bs-modal" class="modal fade modal-md" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true" (onHide)="clearData()" [config]="{backdrop: 'static'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-dark bg-gray-900">
        <h4 class="modal-title"> <i class="icon-info mr-2"></i><span *ngIf="!selectItem?.vendor_id">เพิ่ม
            Vendor</span><span *ngIf="selectItem?.vendor_id">แก้ไข Vendor</span></h4>
        <button type="button" class="close text-light" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form class="form-horizontal mt-2 mb-2">
          <div class="form-group row">
            <label class="col-md-4 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">Vendor
                name<span class="text-danger">*</span> :</span></label>
            <div class="col-md-8">
              <input type="text" [(ngModel)]="selectItem.company_name" class="form-control" placeholder=""
                maxlength="50" [ngModelOptions]="{standalone: true}">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">Phone
                number<span class="text-danger">*</span> :</span></label>
            <div class="col-md-8">
              <input #phoneInput type="text" mask="0000000000" [(ngModel)]="selectItem.phone_number" class="form-control"
                placeholder="" maxlength="10" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="phoneValidate($event)" [ngClass]="{'invalid-input1':valid_phone == false}">
            </div>
          </div>

          <div *ngIf="this.selectItem?.vendor_id" class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">สถานะ<span
                  class="text-danger">*</span>
                :</span></label>
            <div class="col-md-8">
              <kendo-combobox class="w-100" [data]="status_list" [allowCustom]="allowCustom" [textField]="'name'"
                [valueField]="'id'" [value]="status_modal" (valueChange)="handleValueStatusModal($event)"
                [placeholder]="'โปรดระบุ'" [filterable]="true">
              </kendo-combobox>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">Detail
                :</span></label>
            <div class="col-md-8">
              <!-- <input type="text" [(ngModel)]="newsTypeItem.news_type_name_en" name="text-input-en" class="form-control"
                    placeholder="" maxlength="50">
                  <span class="help-block pull-right small text-muted">({{newsTypeItem?.news_type_name_en?.length}}/50)</span> -->
              <textarea [(ngModel)]="selectItem.detail" rows="3" class="form-control" placeholder=""
                [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">Address
                :</span></label>
            <div class="col-md-8">
              <input type="text" [(ngModel)]="selectItem.address" name="text-input-address" class="form-control"
                placeholder="" maxlength="50" [ngModelOptions]="{standalone: true}">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-md-4 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">Email
                :</span></label>
            <div class="col-md-8">
              <input #emailInput type="email" [(ngModel)]="selectItem.email" name="text-input-email"
                class="form-control" placeholder="" maxlength="50" [ngModelOptions]="{standalone: true}"
                [ngClass]="{'invalid-input1':valid_email == false}" (ngModelChange)="emailOnValidatorChange($event)">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">Hashtag
                :</span></label>
            <div class="col-md-8">
              <input type="text" [(ngModel)]="selectItem.hashtag" name="text-input-hashtag" class="form-control"
                placeholder="" maxlength="50" [ngModelOptions]="{standalone: true}">
            </div>
          </div>
        </form>
        <div class="d-flex justify-content-end mt-2 mb-2">
          <button type="button" class="btn btn-secondary" (click)="addModal.hide()">ยกเลิก</button>
          <button
            [disabled]="!(selectItem.company_name && valid_phone && status_modal != null && ((selectItem?.email && valid_email) || !selectItem?.email))"
            *ngIf="selectItem?.vendor_id" type="button" class="btn btn-primary text-white ml-2"
            (click)="editVendor()">แก้ไข</button>
          <button [disabled]="!(selectItem.company_name && valid_phone && ((selectItem?.email && valid_email) || !selectItem?.email))"
            *ngIf="!selectItem?.vendor_id" type="button" class="btn btn-primary text-white ml-2"
            (click)="addVendor()">เพิ่ม</button>
        </div>

      </div>
      <!-- <div class="modal-footer">
              
            </div> -->
    </div>
  </div>
</div>
<div bsModal #deleteModal="bs-modal" class="modal fade modal-md" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" (onHide)="clearData()" [config]="{backdrop: 'static'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-dark bg-gray-900">
        <h4 class="modal-title"> <i class="icon-info mr-2"></i>ลบ Vendor</h4>
        <button type="button" class="close text-light" (click)="deleteModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <h4>คุณต้องการลบใช่หรือไม่</h4>
        </div>
        <div class="mt-2 mb-4 text-center">
          <!-- <h4>{{newsTypeItem?.news_type_name}}</h4> -->
        </div>
        <div class="d-flex justify-content-end mt-2 mb-2">
          <button type="button" class="btn btn-secondary" (click)="deleteModal.hide()">ยกเลิก</button>
          <!-- <button type="button" class="btn btn-primary ml-2" (click)="deleteType(newsTypeItem.id)">ยืนยัน</button> -->
          <button type="button" class="btn btn-primary text-white ml-2" (click)="deleteVendor()">ยืนยัน</button>
        </div>

      </div>
      <!-- <div class="modal-footer">
              
            </div> -->
    </div>
  </div>
</div>

<div bsModal #addModalSub="bs-modal" class="modal fade modal-md" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" (onHide)="clearDataSub()" [config]="{backdrop: 'static'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-dark bg-gray-900">
        <h4 class="modal-title"> <i class="icon-info mr-2"></i><span *ngIf="!selectSubItem?.contact_id">Add vendor
            contact</span><span *ngIf="selectSubItem?.contact_id">Edit vendor contact</span></h4>
        <button type="button" class="close text-light" (click)="addModalSub.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form class="form-horizontal mt-2 mb-2">
          <div class="form-group row">
            <label class="col-md-4 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">Vendor
                contact<span class="text-danger">*</span> :</span></label>
            <div class="col-md-8">
              <input type="text" [(ngModel)]="selectSubItem.contact_name" class="form-control" placeholder=""
                maxlength="50" [ngModelOptions]="{standalone: true}">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">Phone
                number<span class="text-danger">*</span> :</span></label>
            <div class="col-md-8">
              <input type="text" mask="0000000000" [(ngModel)]="selectSubItem.contact_tel" class="form-control"
                placeholder="" maxlength="10" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="phoneSubValidate($event)" [ngClass]="{'invalid-input1':valid_phone_sub == false}">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">สถานะ<span
                  class="text-danger">*</span>
                :</span></label>
            <div class="col-md-8">
              <kendo-combobox class="w-100" [data]="status_list" [allowCustom]="allowCustom" [textField]="'name'"
                [valueField]="'id'" [value]="status_modal_sub" (valueChange)="handleValueStatusModalSub($event)"
                [placeholder]="'โปรดระบุ'" [filterable]="true">
              </kendo-combobox>
            </div>
          </div>


          <div class="form-group row">
            <label class="col-md-4 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">Email
                :</span></label>
            <div class="col-md-8">
              <input #emailSubInput type="email" [(ngModel)]="selectSubItem.contact_email" name="text-input-email"
                class="form-control" placeholder="" maxlength="50" [ngModelOptions]="{standalone: true}"
                [ngClass]="{'invalid-input1':valid_email_sub == false}"
                (ngModelChange)="emailSubOnValidatorChange($event)">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">Vendor Type
                :</span></label>
            <div class="col-md-8">
              <kendo-combobox class="w-100" [data]="vendor_contact_type_list" [allowCustom]="allowCustom"
                [textField]="'name'" [valueField]="'id'" [value]="vendor_contact_type" [filterable]="true"
                (valueChange)="handleValueVendorContactType($event)" [placeholder]="'ไม่ระบุ'">
              </kendo-combobox >
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label"> <span class="float-sm-left float-md-right">Detail
                :</span></label>
            <div class="col-md-8">
              <textarea [(ngModel)]="selectSubItem.contact_detail" rows="3" class="form-control" placeholder=""
                [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </form>
        <div class="d-flex justify-content-end mt-2 mb-2">
          <button type="button" class="btn btn-secondary" (click)="addModalSub.hide()">ยกเลิก</button>
          <button
            [disabled]="!(selectSubItem.contact_name && valid_phone_sub && status_modal_sub != null && ((selectSubItem?.contact_email && valid_email_sub) || !selectSubItem?.contact_email))"
            *ngIf="selectSubItem?.contact_id" type="button" class="btn btn-primary text-white ml-2"
            (click)="editVendorContact()">แก้ไข</button>
          <button [disabled]="!(selectSubItem.contact_name && valid_phone_sub && ((selectSubItem?.contact_email && valid_email_sub) || !selectSubItem?.contact_email))"
            *ngIf="!selectSubItem?.contact_id" type="button" class="btn btn-primary text-white ml-2"
            (click)="addVendorContact()">เพิ่ม</button>
        </div>

      </div>
      <!-- <div class="modal-footer">
            
          </div> -->
    </div>
  </div>
</div>
<div bsModal #deleteModalSub="bs-modal" class="modal fade modal-md" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" (onHide)="clearDataSub()" [config]="{backdrop: 'static'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-dark bg-gray-900">
        <h4 class="modal-title"> <i class="icon-info mr-2"></i>ลบ Vendor</h4>
        <button type="button" class="close text-light" (click)="deleteModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <h4>คุณต้องการลบใช่หรือไม่</h4>
        </div>
        <div class="mt-2 mb-4 text-center">
          <!-- <h4>{{newsTypeItem?.news_type_name}}</h4> -->
        </div>
        <div class="d-flex justify-content-end mt-2 mb-2">
          <button type="button" class="btn btn-secondary" (click)="deleteModalSub.hide()">ยกเลิก</button>
          <!-- <button type="button" class="btn btn-primary ml-2" (click)="deleteType(newsTypeItem.id)">ยืนยัน</button> -->
          <button type="button" class="btn btn-primary text-white ml-2" (click)="deleteVendorContact()">ยืนยัน</button>
        </div>

      </div>
      <!-- <div class="modal-footer">
            
          </div> -->
    </div>
  </div>
</div>
<swal #swalSuccess title="<div class='text-light'>สำเร็จ</div>" type="success" text="" icon="success"></swal>
<swal #swalError title="<div class='text-light'>ไม่สำเร็จ</div>" html="<div class='text-light'>{{res_message}}</div>"
  type="error" icon="error"></swal>